/**
 * The project's one source of randomness (architectural rule 4).
 *
 * Both the procedural surface textures and the derived room trim need variation that is
 * the same on every build — the same profile must produce the same wood grain and the
 * same wainscot panels, or a level stops being reproducible. Seeding both from here
 * means there is a single place where that guarantee lives, and no reason for either to
 * reach for `Math.random()`.
 */

/** Small, fast, deterministic PRNG. Returns draws in [0, 1). */
export function mulberry32(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** FNV-1a: turns a name like a room id or a palette color into a seed. */
export function seedFromString(text: string): number {
  let hash = 2166136261;
  for (const character of text) hash = Math.imul(hash ^ character.charCodeAt(0), 16777619);
  return hash >>> 0;
}
